const imagesTeaserEls = document.querySelectorAll('.images-teaser');

imagesTeaserEls.forEach((imagesTeaserEl) => {
    const items = imagesTeaserEl.querySelectorAll('.images-teaser__item');

    if (items.length > 0) {
        items[0].classList.add('images-teaser__item--active');
    }

    items.forEach((item) => {
        const linkEl = item.querySelector('a');

        if (linkEl) {
            linkEl.addEventListener('mouseover', () => {
                items.forEach((item) => {
                    item.classList.remove('images-teaser__item--active');
                });

                item.classList.add('images-teaser__item--active');
            });
        }
    });
});
